import Vue from 'vue';
import {
    GET_STORE_ADD_GOODS_CATES_REQUEST,
    GET_STORE_ADD_GOODS_CATES_SUCCESS,
    GET_STORE_ADD_GOODS_CATES_FAILURE,
    UPDATE_STORE_ADD_GOODS_PARAMS,
    CLEAR_STORE_ADD_GOODS_CATES
} from '../mutationTypes';

const state = {
    cateLoading: true,
    cate1_id: '',
    cate2_id: '',
    cate3_id: '',
    cateL1: [],
    cateL2: [],
    cateL3: [],
};

const mutations = {
    [GET_STORE_ADD_GOODS_CATES_REQUEST](state) {
        state.cateLoading = true;
    },
    [GET_STORE_ADD_GOODS_CATES_SUCCESS](state, res) {
        state.cateLoading = false;
        const { level } = res;
        state[`cateL${level || 1 || 4}`] = res.list;
    },
    [GET_STORE_ADD_GOODS_CATES_FAILURE](state) {
        state.cateLoading = false;
    },
    [UPDATE_STORE_ADD_GOODS_PARAMS](state, obj) {
        state[obj.k] = obj.val;
    },
    [CLEAR_STORE_ADD_GOODS_CATES](state, level) {
        if (level === 2) {
            // 一级不用清空
            state.cateL2 = [];
            state.cate2_id = '';
            state.cateL3 = [];
            state.cate3_id = '';
        } else if (level === 3) {
            state.cateL3 = [];
            state.cate3_id = '';
        }
    },
};

export const actions = {
    async getStoreAddGoodsCates({ commit }, query) {
        commit(GET_STORE_ADD_GOODS_CATES_REQUEST);
        const { level, cateId, isOrthers} = query;
        const list = await Vue.$ajax.get('getGoodsCate', {
            cateId,
            isOrthers
        });
        const res = {
            list,
            level
        };
        if (!list.errorType) {
            commit(GET_STORE_ADD_GOODS_CATES_SUCCESS, res);
        } else {
            commit(GET_STORE_ADD_GOODS_CATES_FAILURE);
        }
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/storeAddGoods.js